module.exports = __webpack_public_path__ + "static/fonts/382A4A_5_0.63bd39c.eot";